module.exports = __webpack_public_path__ + "static/img/InfoAM.544f760.png";


//////////////////
// WEBPACK FOOTER
// /src/assets/images/InfoAM.png
// module id = yBhv
// module chunks = 1